import { getEnv } from './environment'

// Currently the largest image we render on the bundle detail page is ~1127px wide, load assets at this size
const DEFAULT_ASSET_SIZE = 1128

export function getAssetUrl(assetId: string, size: number = DEFAULT_ASSET_SIZE): string {
  const env = getEnv()
  const portalSlug = env.portal.slug
  return `/api/assets/${portalSlug}/${assetId}?sizex=${size}`
}

/**
 * Normalizes an absolute asset URL returned by the API into a relative URL.
 * Stripping the origin lets the image load via the tix-web proxy/CDN instead of
 * hitting the API host directly.
 */
export function getAssetUrlFromApiUrl(apiUrl: string, size: number = DEFAULT_ASSET_SIZE): string {
  const relative = apiUrl.replace(/^https?:\/\/[^/]+\/v1\//, '/api/')
  const separator = relative.includes('?') ? '&' : '?'
  return `${relative}${separator}sizex=${size}`
}
